<template>
  <div id="app">
    <Header v-if="headerExcludeRoutes.indexOf($route.name) == -1"></Header>
    <div class="page">
      <router-view/>
    </div>
    <!-- 公共提示框 模态框 -->
    <mainApp></mainApp>
    <CustomerService :configObj="configObj"></CustomerService>
    <!-- 部分路由不应该包含这个Footer -->
    <Footer v-if="excludeRoutes.indexOf($route.name) == -1" :configObj="configObj"></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import CustomerService from '@/components/customerService/CustomerService';
import mainApp from '@/components/app/main';
import CommonMixin from './mixins/common'

import '../static/css/data_flex.less';
import '../static/css/nec_funcs.less';

export default {
  mixins: [CommonMixin],
  name: 'App',
  data () {
    return {
      excludeRoutes: ['Login', 'MyAddress', 'AddAddress', 'MyOrder', 'MyShoppingCart'],
      headerExcludeRoutes: ['Login', 'SignUp'],
      configObj: {}
    };
  },
  components: {
    Header,
    Footer,
    mainApp,
    CustomerService
  },
  created(){
    this.getConfig()
  },
  methods: {
    async getConfig() {

      let apiResult = null

      try {
        apiResult = await this.apiGet('get.config')
      } catch (ex) {
        apiResult = null
      }

      this.hideLoading()

      if (this.hasException2(apiResult)) {
        return
      }

      this.configObj = apiResult.obj
      console.log('apiResult11', apiResult)
    }

  },
};
</script>

<style lang="less" scoped>
.page{
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue